import React, { useState } from 'react';
import { Badge } from '@wix/design-system';
import { DATA_HOOKS } from '../../../../dataHooks';
export var CategoryTag = function (_a) {
    var _b;
    var category = _a.category, onClick = _a.onClick, InnerLinkComponentWrapper = _a.innerLinkComponent;
    var _c = useState(false), isHover = _c[0], setIsHover = _c[1];
    if (!category) {
        return null;
    }
    return (React.createElement(InnerLinkComponentWrapper, { onClick: function () { return onClick(category); }, className: "categoryTag", href: (_b = category.uri) !== null && _b !== void 0 ? _b : '', dataHook: DATA_HOOKS.SEARCH_RESULT_ITEM_CATEGORY_NAME, onMouseEnter: function () { return setIsHover(true); }, onMouseLeave: function () { return setIsHover(false); } },
        React.createElement(Badge, { type: "outlined", skin: isHover ? 'neutralStandard' : 'neutralLight', size: "tiny" }, category.name)));
};
//# sourceMappingURL=index.js.map